import withAccountFrame from "./withAccountFrame";

export default {
  withAccountFrame
};
